<template>
    <el-dialog :visible.sync="popup" size="tiny" :before-close="close" i='base_vip' v-if="!isLoading">
        <!-- <div class="top-tab clearfix">
            <div class="tab pull-left" :class="{'active': level === 2}" @click="level = 2">
                <div class="box clearfix">
                    <div class="img-box pull-left" v-if="level !== 2"><img src="/static/images/vip/3.png"></div>
                    <div class="img-box pull-left" v-else><img src="/static/images/vip/4.png"></div>
                    <div class="cont pull-left">
                        <p>白金会员</p>
                        <template v-for="(d, index) in list" v-if="level === d.level">
                            <p :key="index">{{d.value | toPrice}}元/年</p>
                        </template>
                    </div>
                </div>
            </div>
            <div class="tab pull-left" :class="{'active': level === 1}" @click="level = 1">
                <div class="box clearfix">
                    <div class="img-box pull-left" v-if="level === 1"><img src="/static/images/vip/2.png"></div>
                    <div class="img-box pull-left" v-else><img src="/static/images/vip/1.png"></div>
                    <div class="cont pull-left">
                        <p>普通会员</p>
                        <template v-for="(d, index) in list" v-if="level === d.level">
                            <p :key="index">{{d.value | toPrice}}元/年</p>
                        </template>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <p>{{list}}</p> -->
        <template v-for="(d, index) in list">
            <div class="content" i="content" :key="index" v-html="d.value2" v-if="level === d.level" style="width: 100%;"></div>
            <div class="code" :key="index+'s'" v-if="level === d.level == 1">
                <div class="box clearfix">
                    <div class="img-box pull-left"><img :src="d.qrcode" v-if="d.qrcode" /><p class="text-center" v-if="over">二维码已过期</p></div>
                    <div class="cont pull-left">
                        <p>请使用微信支付</p>
                        <p class="price">{{d.value | toPrice}}元/年</p>
                    </div>
              
                </div>
                <p>会员到期时间{{d.validity_time | timeDate}}</p>
            </div>
      
        </template>
    </el-dialog>
</template>
<style rel='stylesheet/scss' lang='scss' scoped>
    @import '../assets/sass/common/tool.scss';
    [i="base_vip"]{
     
        .el-dialog--tiny{
            width: 700px !important;
            .content{
                width: 100%;
            }
        }
        .top-tab{
            width: 100%;
            height: 100px;
            padding: 10px;
            background-color: #ebebeb;
            @include rounded(1000px);
            .tab{
                width: 50%;
                height: 100%;   
                @include rounded(1000px);
                color: #999;
                text-align: center;
                font-size: 20px;
                line-height: 30px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
            
                .box{
                    display: inline-block;
                }

                &.active{
                    background-color: $nav8;
                    color: #fff;
                }

                &:first-child .img-box{
                    padding-top: 2px;
                }

                &:last-child .img-box{
                    padding-top: 5px;
                }
                .cont{
                    padding-top: 2px;
                }
                .img-box{
                    margin-right: 20px;

                    img{
                        display: inline-block;
                    }
                }
            }
        }
        .code{
            text-align: center;
            margin-top: 42px;
            padding-top: 42px;
            border-top: 1px dashed #ddd;

            .box{
                display: inline-block;
            }
            .img-box{
                width: 200px;
                height: 200px;
                margin-right: 25px;

                img{
                    width: 100%;
                }
            }
            .cont{
                padding-top: 50px;
                font-size: 24px;
                line-height: 30px;
                .price{
                    padding-top: 15px;
                    font-size: 30px;
                    color: $nav8;
                }
            }
        }
    }
</style>
<script>
    import Vue from 'vue';
    import { Dialog, Button } from 'element-ui'
    Vue.use(Dialog)
    Vue.use(Button)

    export default{
        data(){
            return {
                level: 1,   // 会员等级
                list: [],   // 价格信息 
                over: false, // 是否过期
                isLoading: true,
                init: true
            }
        },
        props: {
            popup: {
                type: Boolean,
                default: false
            }
        },
        created() {

        },
        computed: {
        },
        methods: {
            close() {
                let that = this;
                clearInterval(that.time);
                that.$store.state.app.vip_popup = false;
                that.$emit('update:popup', false);
            },

            // 获取价格
            getData() {
                let that = this;

                tools.ajax({
                    url: '/api/gallery/designer/pay/config',
                    ajaxData: {},
                    isLoading: true,
                    successFun: function (res) {
                        that.list = res.list;
                    },
                    errorFun: function (error_data, status, headers, error_obj) {
                        tools.alert.error(error_data.error_msg);
                    },
                    type: 'GET'
                });
            },

            // 获取二维码
            getImg(level) {
                let that = this;
                tools.ajax({
                    url: '/api/gallery/designer/pay',
                    ajaxData: {
                        type: 'wechatpay',
                        device: 'native',
                        // callback: location.origin + '',
                        level: level
                    },
                    isLoading: true,
                    successFun: function (res) {
                        let arr = $.extend(true, [], that.list);
                        for (let i of arr) {
                            if(level === i.level) {
                                i.qrcode = res.data.sign.qrcode;
                            }
                        }
                        that.list = $.extend(true, [], arr);
                        that.isLoading = false;

                        if (that.init) {
                            that.init = false;
                            that.time = setInterval(that.getState,3000);
                            setTimeout(() => {
                                that.close();
                            },600000);
                        }
                    },
                    errorFun: function (error_data, status, headers, error_obj) {
                        tools.alert.error(error_data.error_msg);
                    },
                    type: 'POST'
                });
            },

            // 获取支付状态
            getState() {
                let that = this;

                tools.ajax({
                    url: '/api/gallery/designer/check',
                    ajaxData: {
                        phone: that.$store.state.app.vip_phone,
                        is_repay: that.$store.state.app.is_repay ? 1 : undefined,
                    },
                    successFun: function (res) {
                        
                        if (that.$store.state.app.is_repay) {
                            if (res.data.pay_result) {
                                tools.alert.success('支付成功');
                                that.$emit('update:popup', false);
                                that.$store.state.app.is_repay = 0;
                                that.$store.state.app.vip_popup = false;
                            }
                        }else {
                            if (res.data.level > 0) {
                                clearInterval(that.time);
                                that.postCheck();
                            }
                        }
                    },
                    errorFun: function (error_data, status, headers, error_obj) {
                        clearInterval(that.time);
                        tools.alert.error(error_data.error_msg);
                    },
                    type: 'POST'
                });
            },

            postCheck() {
                let that = this;

                tools.ajax({
                    url: '/api/gallery/designer/level/check',
                    ajaxData: {},
                    isLoading: true,
                    successFun: function (res) {
                        tools.cache.set('isArtLogin', 1);
                        that.$emit('update:popup', false);
                        that.$store.state.app.vip_popup = false;
                        let url = decodeURIComponent(decodeURIComponent(tools.url.params('callback')));
                        if (tools.url.params('callback')) {
                            tools.router.push(url);
                        } else {
                            tools.router.push('/');
                        }
                    },
                    errorFun: function (error_data, status, headers, error_obj) {
                        tools.alert.error(error_data.error_msg);
                    },
                    type: 'POST'
                });
            }
        },
        watch: {

        },
        components: {

        },
        filters: {

        },
        mounted() {
            this.getData();
            this.getImg(1);
            this.getImg(2);
        },
        destroyed() {

        }
    }
</script>


// WEBPACK FOOTER //
// vip.vue?44ae54c4